import { Injectable, EventEmitter, OnInit } from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestMethod, Request } from '@angular/http';
import { Observable, Observer } from 'rxjs/Rx';
import 'rxjs/add/operator/map'
import { AppConfig } from '../boot/app.config';
import { DataService } from './data.service';

@Injectable()
export class ConfigurationService {
    private _authToken: any;
    private dashboardConfiguration:any;

    constructor(private dataService: DataService) {}

    ngOnInit() {
    }

    isConfigurationLoaded() {
        if (this.dashboardConfiguration) { 
            return true;
        }
        else {
            return false;
        }
    }

    loadConfiguration() {
        return new Promise((resolve, reject) => {
            this.dataService.getConfiguration().subscribe(
                data => {
                    // 
                    this.dashboardConfiguration = data;
                    localStorage.setItem("dashboardConfiguration", data);
                    resolve(true);
                },
                error => {
                    // handle errors
                    reject(new Error("Could not load configuration - " + error));
                }
            );
        }).catch(this.handleError);
    }

    isLoggedIn() {
        // assume if token is available - user is logged in
        this._authToken = localStorage.getItem("dashboardUser");
        return (this._authToken) ? true : false;
    }

    private handleError = (error: any) => {
        // do nothing
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/configuration.service.ts